import { render, staticRenderFns } from "./chart_two.vue?vue&type=template&id=56d6b485&"
import script from "./chart_two.vue?vue&type=script&lang=js&"
export * from "./chart_two.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports